import { LyneButton } from "components/Lyne/LyneButton";
import { LyneDialog } from "components/Lyne/LyneDialog";
import { useOutputDocumentsPanel } from "providers";
import { useTranslations } from "providers";
import React from "react";

export const OutputDocumentConfirmDialog: React.FC = () => {
  const i18n = useTranslations();

  const { showConfirmDialog, selectedOutputDocument, setShowOutputDocumentsPanel, hideConfirmDialog } =
    useOutputDocumentsPanel();

  if (!selectedOutputDocument) {
    return null;
  }

  const { name, confirmTitle, confirmContent } = selectedOutputDocument;

  return (
    <LyneDialog
      id={`confirm-dialog-${name}`}
      isOpen={showConfirmDialog}
      title={confirmTitle}
      content={confirmContent}
      actions={
        <>
          <LyneButton
            onClick={() => {
              setShowOutputDocumentsPanel(true);
            }}
            text={i18n.Actions_Save}
          />
          <LyneButton
            onClick={() => {
              hideConfirmDialog();
            }}
            text={i18n.Actions_Cancel}
            kind="secondary"
          />
        </>
      }
    />
  );
};
